import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../store/actions/notificationAction';
import { receiveExportAwbs } from '../../store/actions/awbsAction';

import attachmentsRequestHandler from '../../api/attachmentsRemote';

import Documents from './Documents';

import Attachment from '../../models/Attachment';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface DocumentsViewerContainerProps {
  code: string;
  number: string;
  version: number;
  receiveError: (error: ResponseError) => void;
  closeAttachments: (event:any) => void;
  updateExportAwbs: (port: string, gha: number) => void;
  refreshAwbs: boolean;
  checked: boolean;
};

interface DocumentsViewerContainerState {
  attachmentsList: Array<Attachment>;
  key: string;
};

class DocumentsViewerContainer extends Component<DocumentsViewerContainerProps, DocumentsViewerContainerState> {

  state: DocumentsViewerContainerState = {
    attachmentsList: [],
    key: ''
  };

  componentDidMount() {
    this.loadDocuments();
  }

  loadDocuments = ():void => {
    attachmentsRequestHandler.loadAttachments(this.props.code, this.props.number, this.props.version).then((resp: ApiResponse<Array<Attachment>>) => {
      const result: Array<Attachment> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.setState({attachmentsList: result});
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  render() {
    return (
      <Fragment>
        <Documents
          closeAttachments={ this.props.closeAttachments }
          attachmentsList={ this.state.attachmentsList }
          checked={ this.props.checked }
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any, props: any) => {
  return {
    port: state.originPort,
    gha: state.originGhaId
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    updateExportAwbs: (port: string, gha: number) => dispatch(receiveExportAwbs(port, gha))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsViewerContainer);